(function () {
  'use strict';

  const hero = document.querySelector('.regada-hero');
  if (!hero) return;

  const slidesEl = hero.querySelector('.regada-hero__slides');
  if (!slidesEl) return;

  const slides = Array.from(slidesEl.querySelectorAll('.regada-hero__slide'));
  if (slides.length <= 1) return;

  const dotsEl   = hero.querySelector('.regada-hero__dots');
  const dots     = dotsEl ? Array.from(dotsEl.querySelectorAll('.regada-hero__dot')) : [];
  const delay    = parseInt(slidesEl.dataset.autoplay, 10) || 5000;
  const mediaEl  = hero.querySelector('.regada-hero__media');

  let current = 0;
  let timer   = null;

  function goTo(index) {
    const next = ((index % slides.length) + slides.length) % slides.length;
    if (next === current) return;

    slides[current].classList.remove('is-active');
    if (dots[current]) {
      dots[current].classList.remove('is-active');
      dots[current].setAttribute('aria-selected', 'false');
    }

    current = next;

    slides[current].classList.add('is-active');
    if (dots[current]) {
      dots[current].classList.add('is-active');
      dots[current].setAttribute('aria-selected', 'true');
    }
  }

  function startAutoplay() {
    if (timer) return;
    timer = setInterval(function () { goTo(current + 1); }, delay);
  }

  function stopAutoplay() {
    clearInterval(timer);
    timer = null;
  }

  // Autoplay — pause when mouse is over the image panel
  startAutoplay();

  if (mediaEl) {
    mediaEl.addEventListener('mouseenter', stopAutoplay);
    mediaEl.addEventListener('mouseleave', startAutoplay);
    mediaEl.addEventListener('focusin',    stopAutoplay);
    mediaEl.addEventListener('focusout',   startAutoplay);
  }

  // Dot clicks
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      stopAutoplay();
      goTo(i);
      startAutoplay();
    });
  });

  // Touch swipe on the image panel
  var touchStartX = 0;
  var touchStartY = 0;

  if (mediaEl) {
    mediaEl.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    mediaEl.addEventListener('touchend', function (e) {
      var dx = touchStartX - e.changedTouches[0].clientX;
      var dy = touchStartY - e.changedTouches[0].clientY;
      // Only count horizontal swipes (not scroll attempts)
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        stopAutoplay();
        goTo(dx > 0 ? current + 1 : current - 1);
        startAutoplay();
      }
    }, { passive: true });
  }

  // Respect reduced motion — disable autoplay & transitions
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    stopAutoplay();
    slides.forEach(function (s) { s.style.transition = 'none'; });
  }
})();
